import {
    configureStore,
    createAsyncThunk,
    type Action,
    type ThunkAction,
} from "@reduxjs/toolkit";

import {
    useDispatch as useReduxDispatch,
    useSelector as useReduxSelector,
    type TypedUseSelectorHook,
} from "react-redux";

import { reducer } from "./rootReducer";

export const reduxStore = configureStore({
    reducer,
});

/* Types */
export type ReduxStore = typeof reduxStore;
export type ReduxState = ReturnType<typeof reduxStore.getState>;
export type ReduxDispatch = typeof reduxStore.dispatch;
export type ReduxThunkAction<ReturnType = void> = ThunkAction<
    ReturnType,
    ReduxState,
    unknown,
    Action
>;

export const useDispatch = () => useReduxDispatch<ReduxDispatch>();
export const useSelector: TypedUseSelectorHook<ReduxState> = useReduxSelector;

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
    state: ReduxState;
    dispatch: ReduxDispatch;
    rejectValue: string;
}>();

export const selectMainState = (state: ReduxState) => state.main;
export const selectGtoState = (state: ReduxState) => state.gerenciaTecnica;
export const selectLocationState = (state: ReduxState) => state.location;
export const PlanningState = (state: ReduxState) => state.planning;
